import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetPickerComponent } from './components/asset-picker/asset-picker.component';
import { AssetTileComponent } from './components/asset-tile/asset-tile.component';

@NgModule({
  declarations: [AssetPickerComponent, AssetTileComponent],
  imports: [CommonModule],
  exports: [AssetPickerComponent, AssetTileComponent],
})
export class AssetPickerModule {}
